import React from 'react';

function TopSkills(){
    return(
        <div className="top-skills pc-p-6 primary-background">
        <div className="container-fluid px-5">
            <div className="row">
                <div className="col-lg-5 col-md-5 col-12">
                    <div className="skills-tabs">
                        <nav>
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                <button className="nav-link active" id="nav-home-tab" data-toggle="tab"
                                    data-target="#nav-home" type="button" role="tab" aria-controls="nav-home"
                                    aria-selected="true">
                                    Top skills
                                </button>
                                <button className="nav-link" id="nav-profile-tab" data-toggle="tab"
                                    data-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile"
                                    aria-selected="false">
                                    Trending skills
                                </button>
                                <button className="nav-link" id="nav-contact-tab" data-toggle="tab"
                                    data-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact"
                                    aria-selected="false">
                                    Top skills in Pakistan
                                </button>
                                <button className="nav-link" id="nav-catalog-tab" data-toggle="tab"
                                    data-target="#nav-catalog" type="button" role="tab" aria-controls="nav-catalog"
                                    aria-selected="false">
                                    Catalog
                                </button>
                            </div>
                        </nav>
                    </div>
                </div>
                <div className="col-lg-7 col-md-7 col-12">
                    <div className="tab-content" id="nav-tabContent">
                        <div className="tab-pane fade show active" id="nav-home" role="tabpanel"
                            aria-labelledby="nav-home-tab">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-12">
                                    <div className="category-list">
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)">Generative AI Specialists
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Data Entry Specialists
                                                </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Video Editors </a></li>
                                            <li><a href="javascript:void(0)">Data Analyst </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Shopify Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Ruby on Rails Developer
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Android Developer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Bookkeeper </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Content Writer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Copywriter </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Data Scientist </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Front-End Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Game Developer </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12">
                                    <div className="category-list">
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)">Generative AI Specialists
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Data Entry Specialists
                                                </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Video Editors </a></li>
                                            <li><a href="javascript:void(0)">Data Analyst </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Shopify Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Ruby on Rails Developer
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Android Developer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Bookkeeper </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Content Writer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Copywriter </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Data Scientist </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Front-End Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Game Developer </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-12">
                                    <div className="category-list">
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)">Generative AI Specialists
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Data Entry Specialists
                                                </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Video Editors </a></li>
                                            <li><a href="javascript:void(0)">Data Analyst </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Shopify Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Ruby on Rails Developer
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Android Developer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Bookkeeper </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Content Writer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Copywriter </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Data Scientist </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Front-End Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Game Developer </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12">
                                    <div className="category-list">
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)">Generative AI Specialists
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Data Entry Specialists
                                                </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Video Editors </a></li>
                                            <li><a href="javascript:void(0)">Data Analyst </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Shopify Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Ruby on Rails Developer
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Android Developer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Bookkeeper </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Content Writer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Copywriter </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Data Scientist </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Front-End Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Game Developer </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-12">
                                    <div className="category-list">
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)">Generative AI Specialists
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Data Entry Specialists
                                                </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Video Editors </a></li>
                                            <li><a href="javascript:void(0)">Data Analyst </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Shopify Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Ruby on Rails Developer
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Android Developer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Bookkeeper </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Content Writer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Copywriter </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Data Scientist </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Front-End Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Game Developer </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12">
                                    <div className="category-list">
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)">Generative AI Specialists
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Data Entry Specialists
                                                </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Video Editors </a></li>
                                            <li><a href="javascript:void(0)">Data Analyst </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Shopify Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Ruby on Rails Developer
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Android Developer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Bookkeeper </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Content Writer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Copywriter </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Data Scientist </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Front-End Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Game Developer </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="nav-catalog" role="tabpanel" aria-labelledby="nav-catalog-tab">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-12">
                                    <div className="category-list">
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)">Generative AI Specialists
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Data Entry Specialists
                                                </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Video Editors </a></li>
                                            <li><a href="javascript:void(0)">Data Analyst </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Shopify Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Ruby on Rails Developer
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Android Developer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Bookkeeper </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Content Writer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Copywriter </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Data Scientist </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Front-End Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Game Developer </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12">
                                    <div className="category-list">
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)">Generative AI Specialists
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Data Entry Specialists
                                                </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Video Editors </a></li>
                                            <li><a href="javascript:void(0)">Data Analyst </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Shopify Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Ruby on Rails Developer
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Android Developer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Bookkeeper </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Content Writer </a>
                                            </li>
                                            <li><a href="javascript:void(0)">Copywriter </a></li>
                                            <li>
                                                <a href="javascript:void(0)">Data Scientist </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Front-End Developer </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)">Game Developer </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default TopSkills;